export default __webpack_public_path__ + "static/media/mobileSquare.13f6fa9d.svg";